import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { getUserAuthenticated } from 'src/models/auth/selectors';
import { TourStep } from 'src/modules/types';

export const steps: TourStep[] = [
  {
    element: '#featureBranch',
    title: <Text bold>Feature Branches</Text>,
    description: (
      <Text>
        Feature branches are isolated code branches used for developing new
        features or functionality in all our web applications
      </Text>
    ),
  },
  {
    element: '#vmDetails',
    title: <Text bold>VM Details</Text>,
    description: (
      <Text>
        Refers to infrastructure monitoring information displayed in the
        frontend dashboard for development and operations teams
      </Text>
    ),
  },
  {
    element: '#step3',
    title: <Text bold>All Done!</Text>,
    description: <Text>You’re ready to go!</Text>,
  },
];

export const start = { selector: getUserAuthenticated, value: true };
